/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Příjmení`
};

const da_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Efternavn`
};

const de_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Nachname`
};

const en_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Lastname`
};

const es_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Apellido`
};

const fr_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Nom`
};

const hu_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Vezetéknév`
};

const it_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Cognome`
};

const nl_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Achternaam`
};

const pl_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Nazwisko`
};

const pt_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Sobrenome`
};

const sv_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Efternamn`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const lastname = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.lastname(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("lastname", locale)
	if (locale === "cs") return cs_lastname(inputs)
	if (locale === "da") return da_lastname(inputs)
	if (locale === "de") return de_lastname(inputs)
	if (locale === "en") return en_lastname(inputs)
	if (locale === "es") return es_lastname(inputs)
	if (locale === "fr") return fr_lastname(inputs)
	if (locale === "hu") return hu_lastname(inputs)
	if (locale === "it") return it_lastname(inputs)
	if (locale === "nl") return nl_lastname(inputs)
	if (locale === "pl") return pl_lastname(inputs)
	if (locale === "pt") return pt_lastname(inputs)
	return sv_lastname(inputs)
};